export default __webpack_public_path__ + "static/media/edit-solid.4ffe848a.svg";